import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/oidc/token")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const { handleShortLinksOidcToken } = await import(
            "@api/features/short-links-sso/shortLinksOidcHandlers"
          )
          return handleShortLinksOidcToken(request)
        },
      },
    },
  })
)
